<template>
  <div class="pop-txt-wrap pd-vertical-8">
    <div class="tit-h5">{{ t('question_cancel_planned', { plan: 'Starter' }) }}</div>
    <p class="dim">{{ t('alert_keep_plan', { plan: 'Pro' }) }}</p>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();
</script>

<style scoped lang="scss">
.pop-txt-wrap {
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: $size-s;
  align-items: center;
  div {
    word-break: keep-all;
    line-height: 130%;
  }
  p {
    max-width: 280px;
  }
}
</style>
